"use client"

import { HelpCircle, MessageCircle, Zap } from "lucide-react"

export function SupportHeroSection() {
  return (
    <section className="relative bg-accent h-52 flex items-center justify-center overflow-hidden">
      {/* Decorative Icons */}
      <div className="absolute top-4 left-8 text-white/20">
        <HelpCircle className="w-12 h-12" />
      </div>
      <div className="absolute bottom-6 right-12 text-white/20">
        <MessageCircle className="w-14 h-14" />
      </div>
      <div className="absolute top-1/2 right-8 text-white/15">
        <Zap className="w-10 h-10" />
      </div>

      {/* Content */}
      <div className="relative z-10 text-center">
        <p className="text-white/70 text-sm font-medium tracking-wide">WE&apos;RE HERE FOR YOU</p>
      </div>
    </section>
  )
}
